// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1045) return "static/chunks/1045.8897503e8ecca43c.js";
	if (chunkId === 2474) return "static/chunks/2474.269bbb531017e766.js";
	if (chunkId === 9323) return "static/chunks/9323.587195796ffbc6bd.js";
	if (chunkId === 5731) return "static/chunks/5731.e75df83b5e16b759.js";
	if (chunkId === 122) return "static/chunks/122.d59f1ef3033c2b22.js";
	if (chunkId === 1149) return "static/chunks/1149.e1acbc92ac6f1ab6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"665":"d38e02dd0c977b64","2418":"2566033be351ea9b","4663":"d2298062112b64e0","7485":"b896ec4b2e7b5458","7927":"f33f1553cd875bc6","8351":"b4e43ca0947c892a","8485":"af5a64fc015bcb6b"}[chunkId] + ".js";
};